if (document.getElementsByClassName('hero__blob--01').length){
  gsap.to(".hero__blob--01", {
    yPercent: 25,
    ease: "none",
    scrollTrigger: {
      trigger: ".hero__blob--01",
      start: "top",
      end: "bottom",
      scrub: true
    }, 
  });
}

if (document.getElementsByClassName('hero__blob--02').length){
  gsap.to(".hero__blob--02", {
    yPercent: -50,
    ease: "none",
    scrollTrigger: {
      trigger: ".hero__blob--02",
      scrub: true
    }, 
  });
}

if (document.getElementsByClassName('acf-block').length){
  const animationsBlocks = gsap.utils.toArray('.acf-block:not(.acf-block-video):not(.acf-block-separator)');
  
  animationsBlocks.forEach((block, i) => {
    if (i == 0) {
      const animation = gsap.to(block, {duration: 1, opacity: 1, paused: true});
      
      ScrollTrigger.create({
        trigger: block,
        once: true,
        onEnter: self => {
          self.progress === 1 ? animation.progress(1) : animation.play()
        }
      });
    } else {
      if (block.classList.contains('acf-block-testimonials') || block.classList.contains('acf-block-educational-institutions') || block.classList.contains('acf-block-partners') || block.classList.contains('acf-block-button-link')) {
        const animation = gsap.to(block, {duration: 1, opacity: 1, paused: true});
        
        ScrollTrigger.create({
          trigger: block,
          once: true,
          onEnter: self => {
            self.progress === 1 ? animation.progress(1) : animation.play()
          }
        });
      } else {
        gsap.set(block, {opacity: 0, y: 50});
        const animation = gsap.to(block, {duration: 0.8, opacity: 1, y: 0, paused: true});
        
        ScrollTrigger.create({
          trigger: block,
          end: "bottom bottom",
          once: true,
          onEnter: self => {
            self.progress === 1 ? animation.progress(1) : animation.play()
          }
        });
      }
    }
  });
}